/**
 * Exception to help differentiate errors when loging to Sentry.
 */
export class HandledException extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'HandledException';
  }
}
